module.exports = __webpack_public_path__ + "images/bespoke-icon.png";